import { Button } from '@material-ui/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledPrivacyPolicy = styled.div`
  h2 {
    padding-top: 30px;
  }

  h2:first-child {
    padding-top: 0px;
  }

  h3 {
    font-weight: bold;
    font-size: 1.2rem;
    padding: 30px 0px 10px;
    color: #231815;
  }

  h4 {
    font-weight: bold;
    padding: 20px 0px 10px;
  }

  p {
    line-height: 1.5rem;
  }

  ol li {
    line-height: 1.2rem;
    margin-left: 1rem;
    margin-bottom: 10px;
    list-style: decimal;
  }

  ul li {
    margin-top: 1rem;
    margin-left: 3rem;
  }

  @media screen and (max-width: 751px) {
    #Wrap #privacy ul li {
      margin-left: 1.5rem;
    }
  }

  .linkIndex {
    text-align: center;
    margin: 20px auto 0px auto;
  }
`;

const StyledRight = styled.p`
   {
    text-align: right;
  }
`;

const StyledMt20 = styled.p`
   {
    margin-top: 20px;
  }
`;

const StyledInquiry = styled.div`
   {
    background-color: rgba(198, 158, 97, 0.3);
    padding: 10px;
    margin: 10px 0px;
  }
`;

const StyledSmall = styled.p`
   {
    font-size: 0.8rem;
  }
`;

const StyledBold = styled.p`
   {
    font-weight: bold;
  }
`;

/**
 * 個人情報保護に関するページ
 */
const PrivacyPolicy: FC = () => {
  return (
    <StyledPrivacyPolicy>
      <h2>個人情報保護について</h2>
      <h3>HTB個人情報保護方針</h3>
      <StyledRight>
        平成15年11月1日制定
        <br />
        平成29年12月1日改定
      </StyledRight>
      <StyledMt20>
        北海道テレビ放送株式会社(以下HTB)は、個人情報の保護に係る法令等を遵守して、個人情報保護に万全を期します。ただし、報道･番組の取材・放送等に係る個人情報の取り扱いについては、国民の知る権利、表現の自由を守る立場から、立法趣旨と調和を図ります。
      </StyledMt20>
      <h4>個人情報の取得</h4>
      <p>その利用目的を明らかにします。</p>
      <h4>適正な取得</h4>
      <p>適正な方法で、必要な範囲に限り取得します。</p>
      <h4>第三者提供</h4>
      <p>原則として本人の同意を得ずに個人情報を第三者へ提供しません。</p>
      <h4>安全管理</h4>
      <p>責任者を定め､保護体制を構築して、安全管理に努めます。</p>
      <h4>監督･啓発</h4>
      <p>適切な監督と必要な研修･啓発を行います。</p>
      <h4>開示等の要請・苦情の処理</h4>
      <p>本人から個人情報の開示等の要請や苦情があれば誠実に対応します。</p>
      <h4>漏洩等への対応</h4>
      <p>漏洩等に際しては、速やかに調査し、適切な措置を講じます。</p>

      <h2>HTBにおける個人情報の取り扱いについて</h2>
      <StyledRight>
        平成15年11月1日制定
        <br />
        平成17年4月1日改定
        <br />
        平成29年12月1日改定
      </StyledRight>
      <h3>1. 個人情報の利用目的</h3>
      <p>
        お預かりした個人情報の利用目的は、以下のとおりです。例外的な利用は、その都度当社ホームページの当該部分にてその目的を公表します。
      </p>
      <h4>
        放送番組（インターネット上で配信する場合を含みます）やイベントなどの募集への応募によりご提供いただいた個人情報
      </h4>
      <ul>
        <li>
          懸賞・プレゼントなどの抽選・賞品の手配・発送のため
          （当選者については、番組やホームページ上などで、お名前やおおまかな住所を公表することがあります）
        </li>
        <li>番組参加の受け付け・連絡のため</li>
        <li>出演料をお支払いするため</li>
        <li>調査・投票などの手配・発送および謝礼をお支払いするため</li>
        <li>主催･共催イベントのご案内のため</li>
      </ul>
      <h4>HTBのホームページを利用されるうえでご提供いただいた個人情報</h4>
      <ul>
        <li>各種会員制サービスへの登録の確認のため</li>
        <li>メールマガジンなど各種サービスの提供のため</li>
        <li>各種調査などを実施するため</li>
        <li>ご協力いただいた調査に対して謝礼などをお送りするため</li>
      </ul>
      <h4>
        モニター調査などの各種調査を実施するうえでご提供いただいた個人情報
      </h4>
      <ul>
        <li>調査への登録の確認のため</li>
        <li>調査に協力していただく方への連絡のため</li>
        <li>プレゼント・謝礼の手配・発送のため</li>
      </ul>
      <h4>
        放送番組やイベントへのリクエスト・お問い合わせなどの際にご提供いただいた個人情報
      </h4>
      <ul>
        <li>放送番組制作やイベント開催のための参考にさせていただくため</li>
        <li>ご意見などに関する連絡のため</li>
      </ul>
      <h4>その他</h4>
      <ul>
        <li>
          番組やイベント、サービスの改善や新番組・新イベント・新サービスの開発に役立てるため
        </li>
        <li>採用に関連した募集の受け付け・連絡のため</li>
      </ul>
      <h3>2. 個人情報の保存・廃棄</h3>
      <p>
        お預かりした個人情報は、保存期間を定め、期間終了後は消去または廃棄します。なお、定めることができないものについては、一定の保存期間を設定し、その期間が過ぎるごとに、引き続き保存することの可否について検討します。
      </p>
      <h3>3. 個人情報の第三者提供について</h3>
      <p>
        みなさまからご提供いただいた個人情報は、原則として第三者へは開示いたしません。ただし、以下の場合は除きます。
      </p>
      <ul>
        <li>提供者ご本人の同意がある場合</li>
        <li>
          プレゼント応募やイベント・キャンペーン企画などで、当社の厳重な監督・指導のもとで、代理店・運送業者などに個人情報の取り扱い業務を委託もしくは共同利用する場合
        </li>
        <li>法令の定めに基づく場合</li>
        <li>
          人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合
        </li>
        <li>
          公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合
        </li>
        <li>
          国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合
        </li>
        <li>
          オプトアウト手続きを取った場合
          ※個人情報のうち住所、氏名など個人を特定できる情報を削除もしくは加工し個人を特定できなくした上で、サービスの向上を目的として利用させていただく場合があります。
        </li>
      </ul>
      <h3>4. 個人データの安全管理措置について</h3>
      <ul>
        <li>
          総務担当役員を総括担当とし、各部署に管理責任者をおき、適切な取り扱いが行われるよう監督します。
        </li>
        <li>
          従業員に対し個人情報保護に関する研修を行い、保護意識を啓発します。
        </li>
        <li>
          個人データの取扱いを外部委託する場合は､委託先と秘密保持契約を交わし、委託先において当社と同等以上の個人情報保護が担保されることを確認のうえ行います。
        </li>
        <li>
          個人データの取り扱いを委託する場合は、個人情報保護について適正な取り扱いがなされるよう当社が責任をもって監督します。
        </li>
        <li>
          ホームページおよび携帯端末サイトを適切に管理し、個人データの漏洩、紛失、誤用、改ざんなどを防止する合理的な保護策を講じます。
        </li>
        <li>
          個人データを当社以外の者に提供するときは、書面・ＦＡＸ・電子メール等により、本人の同意を得て行います。
        </li>
        <li>
          個人データは利用目的に必要な範囲で最新かつ正確な内容となるよう更新して利用します。
        </li>
        <li>
          個人データの保存期間は、原則として利用目的終了後３ヶ月以内とします。この期間を超える保存期間を定める場合は、公表または通知するように努めます。
        </li>
        <li>
          保存期間を終了した個人データは、裁断・溶解・破砕のほか、情報の復元が不可能な方法で廃棄いたします。
        </li>
      </ul>
      <h3>5. 個人データに関する開示等の要請・お問い合せについて</h3>
      <p>
        個人情報の開示等(利用目的の通知､情報内容の開示、訂正･追加・削除、情報の利用停止・消去)の請求を行う場合は、次の手続きによります。なお、請求と回答は所定の書面（郵送）による方法を原則とします。
      </p>
      <ul>
        <li>
          <p>
            【１】電話で請求用紙の郵送を依頼して必要事項を記入します。
            -（1）本人が請求される場合の確認用書類 -
            人の氏名と住所が記載された公的証明書（運転免許証､健康保険の被保険者証、住民基本台帳カード、パスポート、外国人登録証明書、年金手帳）のうちから２種類を選んでコピーしたもの{' '}
            <br />
            ※確認に使用したコピーは､一定期間終了後に廃棄します。
          </p>
          <ul>
            <li>
              （2） 代理人の方が請求される場合の確認用書類
              <ul>
                <li>
                  本人の氏名と住所が記載された公的証明書（運転免許証、健康保険の被保険者証、住民基本台帳カード、パスポート、外国人登録証明書、年金手帳、等）の中から２種類のコピー
                </li>
                <li>
                  代理人の氏名と住所が記載された公的証明書（運転免許証、健康保険の被保険者証、住民基本台帳カード、パスポート、外国人登録証明書、年金手帳、等）の中から２種類のコピー{' '}
                  <br /> ※確認に使用したコピーは､一定期間終了後に廃棄します。
                </li>
                <li>
                  本人からの委任状（未成年者または成年被後見人の法定代理人の方が請求される場合でも、できる限り本人からの委任状を提出していただくようお願いします）
                </li>
                <li>
                  未成年者または成年被後見人の法定代理人である場合は、そのことを証明する書類
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <p>
            【２】｢必要事項を記入した請求書｣､｢2:の確認用書類｣、｢返送用郵便切手82円分｣を受付窓口に郵送してください。〈手数料が必要な場合は500円分の郵便切手も同封）
          </p>
        </li>
        <li>
          <p>
            【３】利用目的の通知、情報内容の開示請求の場合は、当社は個人情報保護法第30条に基づき、手数料として1件につき500円をお支払いいただきます。500円分の郵便切手を同封してください。上記手続き以外で費用がかかる場合は､別途､請求させていただきます。
            <br />
            なお、情報の訂正･追加・削除､利用停止・消去の請求の場合は、手数料は不要です。
          </p>
        </li>
        <li>
          【４】受け付けた請求書は､該当する個人情報の管理責任者が内容を確認のうえ、受け付け後できるかぎり速やかに､請求用紙記載の住所に回答を発送いたします。もし、請求に応じない場合は、その理由を回答いたします。
          <ul>
            <li>
              利用停止を請求することができるのは、次の３つが理由の場合に限ります。
              <ul>
                <li>（1） 当該個人情報を目的外に利用している場合</li>
                <li>（2） 当該個人情報を不正な手段で入手した場合</li>
                <li>
                  （3） 当該個人情報を本人の同意なく第三者に提供した場合
                  <br />
                  もし、請求に応じられない場合は、その理由を回答いたします。
                </li>
              </ul>
            </li>
            <li>
              請求をお断りする場合
              <br />
              次に該当する場合は、この請求をお断りすることがありますので、あらかじめご了承ください。
              <ul>
                <li>
                  （1）
                  当社が報道または著述を目的として請求者の個人情報を取得・利用したとき
                </li>
                <li>
                  （2）
                  請求に係る個人情報の本人および第三者の生命、身体、財産その他の権利を害するおそれがある場合
                </li>
                <li>
                  （3）
                  当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
                </li>
                <li>（4） 他の法令に違反することとなる場合</li>
                <li>（5） 本人確認ができない場合</li>
                <li>（6） 当社の定めた請求手続きに従わない場合</li>
                <li>（7） 手数料をお支払いいただけない場合</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <p>
            【５】郵送時のご注意
            <br />
            請求書を郵送される際は、記載された個人情報の漏洩などないような対策を施した上で送られることをお願いします。当社到着以前に個人情報の漏洩がありましても、当社では責任を負いかねます。
          </p>
        </li>
      </ul>
      <StyledMt20>
        個人情報の取り扱いに関するお問い合せ、ご意見、苦情は、下記へご連絡ください。
      </StyledMt20>
      <StyledInquiry>
        <StyledBold>北海道テレビ放送株式会社「広報お客様センター」</StyledBold>
        <p>
          ＜住所＞ 〒060–8406 札幌市中央区北1条西1丁目6番地
          <br />
          ＜電話＞ 011–233–6600
        </p>
        <StyledSmall>
          窓口の開設時間は平日（祝日・振替休日・年末年始除く）の午前10時～午後6時です。
          <br />
          直接来社されてのお申出はお受けいたしかねますので、その旨ご了承ください。
        </StyledSmall>
      </StyledInquiry>
      <div className="linkIndex">
        <Button variant="contained" color="primary" component={Link} to="/">
          前のページへ戻る
        </Button>
      </div>
    </StyledPrivacyPolicy>
  );
};

export default PrivacyPolicy;
